<template>
  <div class="tenant-dropdown-wrapper">
    <VaDropdown v-model="isShown" :offset="[9, 0]" class="tenant-dropdown" stick-to-edges>
      <template #anchor>
        <VaButton preset="secondary" color="textPrimary">
          <span class="tenant-dropdown__anchor min-w-max">
            <slot />
            <span class="app-navbar-actions__item username-display">
              {{ displayName }}
            </span>
          </span>
        </VaButton>
      </template>
      <VaDropdownContent
        class="tenant-dropdown__content md:w-60 px-0 py-4 w-full"
        :style="{ '--hover-color': hoverColor }"
      >
        <VaList v-for="group in options" :key="group.name">
          <header v-if="group.name" class="uppercase text-[var(--va-secondary)] opacity-80 font-bold text-xs px-4">
            {{ group.name }}
          </header>
          <VaListItem
            v-for="item in group.list"
            :key="item.name"
            class="menu-item px-4 text-base cursor-pointer h-8"
            @click="handleItemClick(item)"
          >
            <!-- <VaAvatar :src="item.icon" class="pr-1" color="secondary" /> -->
            <VaIcon :name="item.icon" class="pr-1" color="secondary" />
            {{ item.name }}
          </VaListItem>
        </VaList>
      </VaDropdownContent>
    </VaDropdown>
  </div>
</template>

<script lang="ts" setup>
import { computed, inject, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useColors } from 'vuestic-ui'

import { useUserStore } from '../../../../stores/user-store'

const { colors, setHSLAColor } = useColors()
const hoverColor = computed(() => setHSLAColor(colors.focus, { a: 0.1 }))

const store = useUserStore()
const router = useRouter()

const getDisplayName = inject<() => Promise<string>>('get-display-name')!
const displayName = computed(() => store.displayName)

const isShown = ref(false)

type TenantListItem = {
  name: string
  id: string
  icon?: string
}

async function handleItemClick(item: TenantListItem) {
  store.tenantId = item.id
  store.displayName = await getDisplayName()
  router.push({ name: 'dashboard' })
  store.init()
}

type TenantOptions = {
  name: string
  list: TenantListItem[]
}

const options = computed<TenantOptions[]>(() => {
  return [
    {
      name: 'tenants',
      list: store.tenantList.map((tenant) => ({
        name: tenant.name,
        id: tenant.id,
        // icon: tenant.logo,
        icon: 'domain',
      })),
    },
  ]
})
</script>

<style lang="scss">
.profile-dropdown {
  cursor: pointer;

  &__content {
    .menu-item:hover {
      background: var(--hover-color);
    }
  }

  &__anchor {
    display: inline-block;
  }
}

.app-navbar-actions {
  display: flex;
  align-items: center;

  .username-display {
    font-weight: 600;
    color: var(--va-primary);
  }
}
</style>
